/**
 * We have an input called "street", but actually it can not only be a DaData street, because some addresses do not have
 * a street associated with them (e.g. 'г. Улан-Удэ, 111 мкрн, д. 7', '111 мкрн' is actually a settlement).
 * @param {object} data
 * @param {array} types
 * @returns {'street' | 'settlement' | 'city_district' | null} - `null` if the provided suggestion's FIAS level is lower
 * than 'city_district'.
 */
export default function getDaDataEntityName(data, types) {
  for (let i in types) {
    if (!data.hasOwnProperty(types[i]) || !data[types[i]]) {
      continue
    }

    return types[i]
  }

  return null
}
